'use client';

import React from "react";
import Image from '@src/components/atoms/safe-image';
import * as Yup from "yup";
import { useFormik } from "formik";

// Assets
import XIcon from '@public/png/x-1.png';
import IArrowRight from "@public/svg/i-arrow-right"

// Components
import Modal from '@src/components/atoms/modal'
import TextInput from "@src/components/atoms/form/text-input";

const phoneRegExp = /^08\d{8,11}$/;

const validationSchema = Yup.object({
  name: Yup.string().required("Wajib diisi."),
  phone: Yup.string().required("Wajib diisi.").matches(phoneRegExp, "Nomor HP tidak valid. Pastikan diawali dengan 08 dan terdiri dari 10-13 digit")
});

const ModalLeads = ({ onClose, onSubmit, defaultName, defaultPhone, ctaBtnClassName, ...props }) => {
  const formik = useFormik({
    initialValues: {
      name: defaultName || "",
      phone: defaultPhone || "",
    },
    validationSchema,
    onSubmit,
    validateOnMount: true,
  });

  const handleChangePhone = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length > 1 && !value.startsWith("08")) {
      value = "08" + value.replace(/^0+/, "");
    }
    formik.setFieldValue("phone", value); // Update Formik state
  };


  return (
    <Modal {...props} onClose={onClose} className="!items-start dd2-xl:hidden">
      <form onSubmit={formik.handleSubmit} className='relative mt-[56px] z-[42] w-[360px] rounded-[16px] bg-[#FAFAFA]'>
        <button type="button" className='absolute z-[43] p-1 -top-8 left-0 flex justify-center items-center bg-white rounded-[40px]'>
          <Image
            width={16}
            height={16}
            src={XIcon}
            alt='Close'
            className='object-contain'
            onClick={onClose}
          />
        </button>

        <p className='px-4 mt-4 text-[21px]/[25.2px] font-satoshi-bold tracking-[-0.42px] mb-2'>Isi data dulu, yuk</p>
        <p className='px-4 text-[14px]/[19.6px] font-satoshi text-[#040704] mb-[12px]'>Kami cuma butuh sedikit info biar bisa hubungkan kamu ke marketing properti ini.</p>

        <div className="px-4 bg-[#FAFAFA] rounded-[12px] mb-[12px] pb-[12px] border-b-[0.5px] border-dashed border-[#DEDFDE]">
          <TextInput
            required
            name="name"
            value={formik.values.name}
            placeholder="Tulis namamu di sini"
            onChange={formik.handleChange}
            error={formik.touched.name ? formik.errors.name : ""}
            className={`text-[17px]/[21.2px] tracking-[-0.17px] font-satoshi text-[#040704] border border-solid bg-white rounded-[8px] px-4 h-[40px] w-full`}
            wrapperClassName="mb-[12px]"
          />
          <TextInput
            required
            placeholder="Nomor WhatsApp"
            name="phone"
            onChange={handleChangePhone}
            value={formik.values.phone}
            error={formik.touched.phone ? formik.errors.phone : ""}
            className={`text-[17px]/[21.2px] tracking-[-0.17px] font-satoshi text-[#040704] border border-solid bg-white rounded-[8px] px-4 h-[40px] w-full`}
            wrapperClassName="mb-[12px]"
          />

          <p className="text-[11px]/[15.4px] font-satoshi tracking-[0.11px] text-[#686A68]">Setelah ini, kamu akan diarahkan ke WhatsApp untuk ngobrol langsung dengan marketing properti.</p>
        </div>

        <div className="px-4 pb-4">
          <button type="submit" className={`flex w-full items-center justify-center gap-1 w-fit rounded-[8px] p-[12px] bg-[#252526] text-[17px]/[23.8px] text-white font-satoshi-bold tracking-[-0.17px] ${ctaBtnClassName}`}>Hubungi via WhatsApp</button>
        </div>

        <div className="px-4 pb-2 mb-4 pt-1 bg-[#EBF0F7]">
          <p className="text-[11px]/[15.4px] font-satoshi tracking-[0.11px] text-[#3268AE]">Dengan mengirim data, kamu menyetujui <span className="underline cursor-pointer font-satoshi-bold">Syarat Pengguna</span> dan <span className="font-satoshi-bold">Kebijakan Privasi</span> kami.</p>
        </div>
      </form>
    </Modal>
  )
}

const ModalLeadsMobile = ({ onClose, onSubmit, defaultName, defaultPhone, ctaBtnClassName, ...props }) => {
  const formik = useFormik({
    initialValues: {
      name: defaultName || "",
      phone: defaultPhone || "",
    },
    validationSchema,
    onSubmit,
    validateOnMount: true,
  });

  const handleChangePhone = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length > 1 && !value.startsWith("08")) {
      value = "08" + value.replace(/^0+/, "");
    }
    formik.setFieldValue("phone", value); // Update Formik state
  };

  return (
    <Modal {...props} onClose={onClose} className="!items-start hidden dd2-xl:flex">
      <form onSubmit={formik.handleSubmit} className='relative z-[42] w-screen h-screen bg-[#FAFAFA] pb-[109px]'>
        <div className="flex items-center gap-1 py-[12px] px-4 border-b-[0.5px] border-solid border-[#DEDFDE]">
          <div onClick={onClose} className="rotate-180">
            <IArrowRight width={16} height={16} />
          </div>
          <span className="text-[14px]/[19.6px] font-satoshi-bold text-[#040704]">Kembali</span>
        </div>

        <p className='px-4 mt-4 text-[21px]/[25.2px] font-satoshi-bold tracking-[-0.42px] mb-2'>Isi data dulu, yuk</p>
        <p className='px-4 text-[14px]/[19.6px] font-satoshi text-[#040704] mb-[12px]'>Kami cuma butuh sedikit info biar bisa hubungkan kamu ke marketing properti ini.</p>

        <div className="px-4 bg-[#FAFAFA] rounded-[12px] mb-[12px] pb-[12px] border-b-[0.5px] border-dashed border-[#DEDFDE]">
          <TextInput
            required
            name="name"
            value={formik.values.name}
            placeholder="Tulis namamu di sini"
            onChange={formik.handleChange}
            error={formik.touched.name ? formik.errors.name : ""}
            className={`text-[17px]/[21.2px] tracking-[-0.17px] font-satoshi text-[#040704] border border-solid bg-white rounded-[8px] px-4 h-[40px] w-full`}
            wrapperClassName="mb-[12px]"
          />
          <TextInput
            required
            placeholder="Nomor WhatsApp"
            name="phone"
            onChange={handleChangePhone}
            value={formik.values.phone}
            error={formik.touched.phone ? formik.errors.phone : ""}
            className={`text-[17px]/[21.2px] tracking-[-0.17px] font-satoshi text-[#040704] border border-solid bg-white rounded-[8px] px-4 h-[40px] w-full`}
            wrapperClassName="mb-[12px]"
          />

          <p className="text-[11px]/[15.4px] font-satoshi tracking-[0.11px] text-[#686A68]">Setelah ini, kamu akan diarahkan ke WhatsApp untuk ngobrol langsung dengan marketing properti.</p>
        </div>

        <div className="fixed pt-2 bottom-0 left-0 z-[43] w-screen border-t-[0.5px] border-dashed border-[#DEDFDE] bg-[#fff] shadow-[0px_-4px_8px_0_rgba(4,7,4,0.08)]">
          <div className="px-4 pb-4">
            <button type="submit" className={`flex w-full items-center justify-center gap-1 w-fit rounded-[8px] py-2 px-[12px] bg-[#252526] text-[17px]/[23.8px] text-white font-satoshi-bold tracking-[-0.17px] ${ctaBtnClassName}`}>Hubungi via WhatsApp</button>
          </div>

          <div className="px-4 pb-2 mb-4 pt-1 bg-[#EBF0F7]">
            <p className="text-[11px]/[15.4px] font-satoshi tracking-[0.11px] text-[#3268AE]">Dengan mengirim data, kamu menyetujui <span className="underline cursor-pointer font-satoshi-bold">Syarat Pengguna</span> dan <span className="font-satoshi-bold">Kebijakan Privasi</span> kami.</p>
          </div>

        </div>
      </form>
    </Modal>
  )
}

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null
  return (
    <>
      <ModalLeads isOpen={isOpen} {...props} />
      <ModalLeadsMobile isOpen={isOpen} {...props} />
    </>
  )
}

export default Wrapper